import { BillService } from './../../service/bill.service';
import { deepCopy, getFacilityByPermission, isNullOrEmpty, isEmpty } from 'src/app/core/utils/common-functions';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PageInfo } from 'src/app/core/models/page-info';
import { Table } from 'primeng/table';
import { ConfirmEventType } from 'primeng/api';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { DatePipe } from '@angular/common';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { endOfDay, startOfDay } from 'date-fns';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { ChipsAddEvent, ChipsRemoveEvent } from 'primeng/chips';

@Component({
  selector: 'laas-bill',
  templateUrl: './bill.component.html',
  styleUrls: ['./bill.component.scss']
})
export class BillComponent extends SessionBaseComponent implements OnInit {

  @ViewChild('billDate') billDate!: CalendarComponent;

  isSearchFormOpen: boolean;
  isHeaderLoading: boolean;
  isDetailLoading: boolean;
  checkBillLoading: boolean = false;
  canEditTable: boolean;
  canCheckBill: boolean = false;
  isShowAddBillModel: boolean;
  headerChecked: boolean;
  searchForm: FormGroup;
  isForwarder: boolean;
  isShowBillingBulkImport: boolean = false;
  isShowExcelModal: boolean;
  showCheckModal: boolean = false;

  editMode: boolean;

  carrierPaymentByOptions: any[];
  orgIdOptions: any[];
  statusOptions: any[];
  inOutTypeOptions: any[];
  checkBillOptions: any[] = [];
  importTypeOptions: any[];
  invoiceTypeOptions: any[];
  formatTypeOptions: any[];
  flowBillTypeOptions: any[];
  billDateOptions: any[];
  billTypeOptions: any[];
  currencyOptions: any[];
  paymentMethodOptions: any[];
  termsIdOptions: any[];
  billCodeKeyOptions: any[];
  billCodeKeyOptionsOriginal: any[];
  billCodeKey: string;

  statusAuthority: any[];

  cloneTableValue: any;
  tableValue: any[];
  tableColumns: any[];
  selectedTableColumns: any[];
  selectedRow: any;
  previousSelectedRow: any;
  selectedRowsWithCheckBox: any[];

  checkBillType: string | null = null;
  checkBillTarget: string[] = [];

  first: number;
  pageInfo: PageInfo;
  sortInfo: [{ property: string; direction: number }] | null;

  pageDropDownList: number[];

  readonly viewPermissionCode = PermissionConstants.ViewBilling;
  readonly editPermissionCode = PermissionConstants.EditBilling;
  readonly checkPermissionCode = PermissionConstants.CheckBilling;
  currentLang: string = this.laasSetting.language;

  @ViewChild('dataTable') dataTable!: Table;

  constructor(injector: Injector, private formBuilder: FormBuilder, private dropdownOptionsService: DropdownOptionsService,
    private commonDataService: CommonDataService, private facilityService: FacilityService, private billService: BillService,
    private datePipe: DatePipe) {
    super(injector);
    this.isSearchFormOpen = true;
    this.isHeaderLoading = false;
    this.isDetailLoading = false;
    this.canEditTable = false;
    this.headerChecked = false;
    this.isForwarder = false;

    this.editMode = false;
    this.isShowAddBillModel = false;
    this.isShowExcelModal = false;

    this.statusOptions = [];
    this.orgIdOptions = [];
    this.inOutTypeOptions = [];
    this.importTypeOptions = [];
    this.invoiceTypeOptions = [];
    this.formatTypeOptions = [];
    this.carrierPaymentByOptions = [];
    this.flowBillTypeOptions = [];
    this.billDateOptions = [];
    this.billTypeOptions = [];
    this.currencyOptions = [];
    this.paymentMethodOptions = [];
    this.termsIdOptions = [];

    this.statusAuthority = ['0', '1', '2', '6', '7', '8'];
    this.billCodeKeyOptions = [];
    this.billCodeKeyOptionsOriginal = [];

    this.tableValue = [];
    this.tableColumns = [];
    this.selectedTableColumns = [];
    this.selectedRowsWithCheckBox = [];
    this.billCodeKey = "";

    this.previousSelectedRow = this.selectedRow;

    this.first = 0;
    this.pageInfo = {
      pageSize: 100,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };

    this.pageDropDownList = [100, 300, 500];

    this.sortInfo = null;

    this.searchForm = this.formBuilder.group({
      carrierPaymentBy: null,
      billingNoStart: null,
      billingNoEnd: null,
      billCorp: null,
      guiNo: null,
      accountCode: null,
      billDtStart: null,
      billDtEnd: null,
      billingStatusList: null,
      inOutType: null,
      expressBill: null,
      doNo: null,
      adNo: null,
      guiId: null,
      uploadBatchNo: null,
      billShipper: null,
      docNo: null,
      diffAmountStart: null,
      diffAmountEnd: null,
      diffRatioStart: null,
      diffRatioEnd: null,
      importType: null,
      billDateType: "C",
      billDate: null,
      facilityList: [null],
      billingNoList: [null],
      consolidationNoList: [null],
      containerNumberList: [null]
    });
  }

  @Input() get selectedColumns(): any[] {
    return this.selectedTableColumns;
  }

  set selectedColumns(cols: any[]) {
    this.selectedTableColumns = this.tableColumns.filter(col => cols.includes(col));
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    // permission Codes
    this.permissionCodes = (
      Object.values(this.userProfile.roles).reduce(
        (c: any, i: any) => c.concat(i.permissions),
        []
      ) as any
    ).map((x: any) => {
      return x.permissionCode;
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'BillingStatus').subscribe({
      next: result => {
        this.tableColumns = this.billTableTranslation();
        this.selectedTableColumns = this.tableColumns;
        this.statusOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'BillInOutType').subscribe({
      next: result => {
        this.inOutTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          };
        });
        // 目前僅進出口報關有檢查功能
        this.checkBillOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
            disabled: !['A','B'].includes(x.codeKey)
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InvoiceType').subscribe({
      next: result => {
        this.invoiceTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'OriginFormatType').subscribe({
      next: result => {
        this.formatTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'BillDate').subscribe({
      next: result => {
        this.billDateOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.facilityService.getLetterOrgOptions(this.laasSetting.facility, '').subscribe({
      next: result => {
        this.orgIdOptions = [...result].map((x: any) => {
          return {
            label: `${x.legalEntityOUCode} - ${x.legalEntityOUName}`,
            value: x.legalEntityOUCode,
          };
        });
      }
    })

    this.dropdownOptionsService.getForwarderOptions()
      .subscribe({
        next: result => {
          this.carrierPaymentByOptions = [...result].map((x: any) => {
            return {
              label: `${x.optionDesc}`,
              value: x.optionCode,
            };
          });
        }
      });

    this.facilityService.getImportTypeOptions()
      .subscribe({
        next: result => {
          this.importTypeOptions = [...result].map((x: any) => {
            return {
              label: `${x.optionCode} - ${x.optionDesc}`,
              value: x.optionCode,
            };
          });
        }
      });

    this.facilityService.getFlowBillTypeOption(this.laasSetting.facility)
      .subscribe({
        next: result => {
          this.flowBillTypeOptions = [...result].map((x: any) => {
            return {
              label: `${x.optionCode} - ${x.optionDesc}`,
              value: x.optionCode,
            };
          });
        }
      });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'BillType').subscribe({
      next: result => {
        this.billTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.facilityService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode} - ${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getExpenseOptions('PaymentMethod', null).subscribe({
      next: result => {
        this.paymentMethodOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode} - ${x.optionDesc}`,
            value: `${x.optionCode}`,
          };
        });
      }
    });

    this.facilityService.getExpenseOptions('SHT_BILL_ORIGIN.TERMS', null).subscribe({
      next: result => {
        this.termsIdOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode} - ${x.optionDesc}`,
            value: `${x.optionCode}`,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'BillingExcelType').subscribe({
      next: result => {
        this.billCodeKeyOptionsOriginal = [...result].sort((a, b) => (a.codeKey || "").localeCompare(b.codeKey || "")).map((x: any) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          };
        });
        this.billCodeKeyOptions = this.billCodeKeyOptionsOriginal;
      }
    });

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.viewPermissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }
    this.canEditTable = this.permissionCodes.includes(this.editPermissionCode);
    this.canCheckBill = this.permissionCodes.includes(this.checkPermissionCode);

    console.log(this.userProfile)
    if (this.userProfile.userType == "Forwarder") {
      this.searchForm.get("carrierPaymentBy")?.patchValue(this.userProfile.roles[0].scopes[0].forwarderCode)
      this.isForwarder = true;
    }

    // 批次上傳成功導到查詢頁面
    const routeData = this.routeStateService.getCurrentAndConsume()?.data;
    if (!isNullOrEmpty(routeData)) {
      let temp =[];
      if(!isNullOrEmpty(routeData.uploadBatchNo)){
        temp[0] = routeData.uploadBatchNo;
        this.searchForm.controls.uploadBatchNo.setValue(temp);
      }else if(!isNullOrEmpty(routeData.inOutNo)){
        this.searchForm.controls.billingNoStart.setValue(routeData.inOutNo);
        this.searchForm.controls.billingNoEnd.setValue(routeData.inOutNo);
      }
      this.resetPageInfo();
      this.searchBtnClick();
    }

  }

  searchBtnClick() {

    if (this.notSaveConfirm()) {
      this.confirmationService.confirm({
        message: this.translateService.instant('NoEvidenceCheck.Confirm.SaveOrNot'),
        header: this.translateService.instant('NoEvidenceCheck.Confirm.Header'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.saveChange();
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              this.resetPageInfo();
              this.doSearchBill();
              break;
            case ConfirmEventType.CANCEL:
              break;
          }
        }
      })
    } else {
      this.resetPageInfo();
      this.doSearchBill();
    }

  }

  doSearchBill() {
    let request = deepCopy(this.searchForm.value);
    request.billingStatusList = Array.isArray(request.billingStatusList) && request.billingStatusList.length === 0 ? null : request.billingStatusList;
    request.adNo = Array.isArray(request.adNo) && request.adNo.length === 0 ? null : request.adNo;
    request.doNo = Array.isArray(request.doNo) && request.doNo.length === 0 ? null : request.doNo;
    request.expressBill = Array.isArray(request.expressBill) && request.expressBill.length === 0 ? null : request.expressBill;
    request.guiId = Array.isArray(request.guiId) && request.guiId.length === 0 ? null : request.guiId;
    request.guiNo = Array.isArray(request.guiNo) && request.guiNo.length === 0 ? null : request.guiNo;
    request.uploadBatchNo = Array.isArray(request.uploadBatchNo) && request.uploadBatchNo.length === 0 ? null : request.uploadBatchNo;
    request.billingNoList = Array.isArray(request.billingNoList) && request.billingNoList.length === 0 ? null : request.billingNoList;
    request.consolidationNoList = Array.isArray(request.consolidationNoList) && request.consolidationNoList.length === 0 ? null : request.consolidationNoList;
    request.containerNumberList = Array.isArray(request.containerNumberList) && request.containerNumberList.length === 0 ? null : request.containerNumberList;

    request.facility = this.laasSetting.facility;
    request.userName = this.userProfile.userName;
    request.userUUId = this.userProfile.uuid;
    request.userType = this.userProfile.userType;
    request.authToken = this.authenticationService.currentToken;
    request.pageSize = this.pageInfo.pageSize;
    request.pageIndex = this.pageInfo.pageIndex;
    request.sortInfo = this.sortInfo;
    if (isEmpty(request.facilityList)) {
      request.facilityList = getFacilityByPermission(this.userProfile, "ViewBilling");
    }

    this.isHeaderLoading = true;

    this.billService.searchBill(request).subscribe({
      next: result => {
        const pageList = result.content;
        this.tableValue = pageList;
        this.putRowId(this.tableValue);

        // 日期轉換
        for (const row of this.tableValue) {
          if (!isNullOrEmpty(row.guiDt)) {
            row.guiDt = new Date(row.guiDt);
          }
          if (!isNullOrEmpty(row.dueDt)) {
            row.dueDt = new Date(row.dueDt);
          }
        }

        this.cloneTableValue = deepCopy(this.tableValue);
        //更改總數量資料
        this.pageInfo.totalRecords = result.totalElements;
        if (this.pageInfo.totalRecords > 500) {
          if (this.pageDropDownList.length == 4) {
            this.pageDropDownList[3] = this.pageInfo.totalRecords
          } else{
            this.pageDropDownList.push(this.pageInfo.totalRecords);
          }
        } else {
          this.pageDropDownList = [100, 300, 500];
        }

        // 重新抓取資料後取消編輯
        this.selectedRow = this.tableValue[0]
        this.dataTable.cancelRowEdit(this.previousSelectedRow);
        this.editMode = false;

        this.isHeaderLoading = false;
        this.isSearchFormOpen = false;
        this.headerChecked = false;
        this.selectedRowsWithCheckBox = [];
      }
    })

  }

  putRowId(array: any[]) {
    let rowId = 1;
    for (const val of array) {
      val.rowId = rowId;
      rowId = rowId + 1;
    }
  }
  resetBtnClick() {
    this.billDate.ngOnInit();
    this.searchForm.controls.billDtStart.setValue(null);
    this.searchForm.controls.billDtEnd.setValue(null);
    if (this.isForwarder) {
      const forwarderCode = this.searchForm.get("carrierPaymentBy")?.value;
      const billDtType = this.searchForm.get("billDateType")?.value;
      this.searchForm.reset()
      this.searchForm.get("carrierPaymentBy")?.patchValue(forwarderCode);
      this.searchForm.get("billDateType")?.patchValue(billDtType);
    } else {
      const billDtType = this.searchForm.get("billDateType")?.value;
      this.searchForm.reset()
      this.searchForm.get("billDateType")?.patchValue(billDtType);
    }

  }

  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.doSearchBill();
  }

  tableSort(event: any): void {
    this.resetPageInfo();
    this.sortInfo = [{ property: event.field, direction: event.order }];
    this.doSearchBill();
  }

  dialogVisibleChange(val: boolean) {
    this.isShowAddBillModel = val;
  }

  importdailyRate(event: any): void {
    this.isShowAddBillModel = false;
  }

  selectAllOrUnSelectAll(event: any) {
    if (this.headerChecked) {
      this.selectedRowsWithCheckBox = this.tableValue
    } else {
      this.selectedRowsWithCheckBox = []
    }
  }

  onRowClick(rowData: any) {
    this.selectedRow = rowData;
    if (this.editMode) {
      this.doSwitchRow()
    }
  }

  doSwitchRow() {
    this.dataTable.cancelRowEdit(this.previousSelectedRow);
    if (this.statusAuthority.includes(this.selectedRow.billingStatus)) {
      this.dataTable.initRowEdit(this.selectedRow);
    }
    this.previousSelectedRow = deepCopy(this.selectedRow);

  }

  switchEditMode() {
    if (this.editMode) {
      if (this.notSaveConfirm()) {
        this.confirmationService.confirm({
          message: this.translateService.instant('NoEvidenceCheck.Confirm.SaveOrNot'),
          header: this.translateService.instant('NoEvidenceCheck.Confirm.Header'),
          icon: 'pi pi-info-circle',
          accept: () => {
            this.saveChange();
          },
          reject: (type: any) => {
            switch (type) {
              case ConfirmEventType.REJECT:
                this.dataTable.cancelRowEdit(this.selectedRow);
                this.editMode = false;
                break;
              case ConfirmEventType.CANCEL:
                break;
            }
          }
        })
      } else {
        this.dataTable.cancelRowEdit(this.selectedRow);
        this.editMode = false;
      }
    } else if (this.selectedRow) {

      this.doSwitchRow();
      this.editMode = true;
    }
  }

  saveBtnClick() {
    this.confirmationService.confirm({
      message: this.translateService.instant('NoEvidenceCheck.Confirm.Save'),
      header: this.translateService.instant('NoEvidenceCheck.Confirm.Header'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.saveChange();
      }
    })
  }
  saveChange() {
    let updateDataArr = [];

    for (const rowVal of this.tableValue) {
      for (const cloneRowVal of this.cloneTableValue) {
        if (rowVal.rowId == cloneRowVal.rowId) {
          if (JSON.stringify(rowVal) != JSON.stringify(cloneRowVal)) {
            const isValid = this.validateUpdateData(rowVal);
            if (!isValid) return;

            const updateData = {
              seqNo: rowVal.seqNo, guiNo: rowVal.guiNo, expressBill: rowVal.expressBill,
              carrierPaymentBy: rowVal.carrierPaymentBy, guiAmount: rowVal.guiAmount, amount: rowVal.amount,
              linePayAmount: rowVal.linePayAmount, businessTaxBaseAmount: rowVal.businessTaxBaseAmount,
              accountCode: rowVal.accountCode, guiDt: rowVal.guiDt, invoiceType: rowVal.invoiceType, guiCurrency: rowVal.guiCurrency,
              description: rowVal.description, vendorDescription: rowVal.vendorDescription,
              paymentMethod: rowVal.paymentMethod, termsId: rowVal.termsId, dueDt: rowVal.dueDt, linePayCurrency: rowVal.linePayCurrency,
              linePayRate: rowVal.linePayRate, updateUser: this.userProfile.userName, diffRatio: rowVal.diffRatio, diffAmount: rowVal.diffAmount
            }
            updateDataArr.push(updateData);
          }
        }
      }
    }

    this.billService.updateBill(updateDataArr).subscribe({
      next: result => {
        this.doSearchBill();
        this.toastService.success(this.translateService.instant('NoEvidenceCheck.Toast.SaveSuccess'))
      },
      error: err => {
        this.toastErrorMessage(err.error);
      }
    })
  }

  validateUpdateData(rowData:any): boolean {
    if (rowData.expressBill && rowData.expressBill.length > 50) {
      const errorMsg = '\r\n' + '單據號碼: ' + rowData.billingNo;
      this.toastService.warn(this.translateService.instant('BillSearch.BillAdd.Error.ExpressBillInvalid') + errorMsg);
      return false;
    }
    return true;
  }

  notSaveConfirm(): boolean {
    if (this.editMode) {
      if (JSON.stringify(this.tableValue) != JSON.stringify(this.cloneTableValue)) {
        return true
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  async transformLinePayAmount(rowData: any) {
    let dailyRate = 1;
    if (rowData.guiCurrency && rowData.linePayCurrency) {
      dailyRate = await this.billService.getDailyRate(rowData.billCorp, rowData.guiCurrency, rowData.linePayCurrency);
      if (dailyRate) {
        rowData.linePayRate = dailyRate;
      } else {
        dailyRate = 0
        rowData.linePayRate = dailyRate;
      }

    }
    if (!rowData.amount) {
      rowData.amount = 0;
    }

    rowData.linePayAmount = rowData.amount * dailyRate;
  }

  resetPageInfo() {
    this.pageInfo = {
      pageSize: this.dataTable.rows ?? 100,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };
    this.first = 0;
  }


  // translate table
  billTableTranslation(): any[] {
    var fields: string[];
    var jsons: string[];
    var tmpcolumn: any[] = [];

    fields = ['seqNo', 'billingNo', 'billCorp', 'guiId', 'guiNo', 'expressBill', 'consolidationNo','carrierPaymentBy',
      'billingStatus', 'preCurrencyCode', 'estimatedAmount', 'guiAmount', 'amount', 'linePayAmount', 'businessTaxBaseAmount', 'applyAmount', 'applyDt', 'accountCode',
      'billType', 'uploadBatchNo', 'guiDt', 'invoiceType', 'guiCurrency', 'description', 'vendorDescription', 'paymentMethod', 'termsId',
      'dueDt', 'linePayCurrency', 'linePayRate', 'confirmDescription', 'confirmBy', 'applyDt', 'cancelDt',
      'cancelUser', 'cancelDesc', 'createUser', 'createDt', 'updateUser', 'updateDt', 'facility', 'inOutType', 'diffRatio', 'diffAmount'];

    jsons = ['BillSearch.MainTable.Column.SeqNo', 'BillSearch.MainTable.Column.InOutKey',
      'BillSearch.MainTable.Column.BillCorp', 'BillSearch.MainTable.Column.GUIId', 'BillSearch.MainTable.Column.GUINo',
      'BillSearch.MainTable.Column.ExpressBill', 'BillSearch.MainTable.Column.ConsolidationNo', 'BillSearch.MainTable.Column.VendorName', 'BillSearch.MainTable.Column.Status',
      'BillSearch.MainTable.Column.PreCurrencyCode', 'BillSearch.MainTable.Column.EstimatedAmount', 'BillSearch.MainTable.Column.GUIAmount',
      'BillSearch.MainTable.Column.Amount', 'BillSearch.MainTable.Column.LinePayAmount', 'BillSearch.MainTable.Column.BusinessTaxBaseAmount',
      'BillSearch.MainTable.Column.ApplyAmount', 'BillSearch.MainTable.Column.ApplyDt', 'BillSearch.MainTable.Column.AccountCode', 'BillSearch.MainTable.Column.BillType',
      'BillSearch.MainTable.Column.UploadBatchNo', 'BillSearch.MainTable.Column.GUIDt', 'BillSearch.MainTable.Column.InvoiceType',
      'BillSearch.MainTable.Column.GUICurrency', 'BillSearch.MainTable.Column.Description', 'BillSearch.MainTable.Column.VendorDescription',
      'BillSearch.MainTable.Column.PaymentMethod', 'BillSearch.MainTable.Column.TermsId', 'BillSearch.MainTable.Column.DueDt',
      'BillSearch.MainTable.Column.LinePayCurrency', 'BillSearch.MainTable.Column.LinePayRate', 'BillSearch.MainTable.Column.ConfirmDescription',
      'BillSearch.MainTable.Column.ConfirmBy', 'BillSearch.MainTable.Column.ApplyDt', 'BillSearch.MainTable.Column.CancelDt',
      'BillSearch.MainTable.Column.CancelUser', 'BillSearch.MainTable.Column.CancelDesc', 'BillSearch.MainTable.Column.CreateUser',
      'BillSearch.MainTable.Column.CreateDt', 'BillSearch.MainTable.Column.UpdateUser', 'BillSearch.MainTable.Column.UpdateDt', 'BillSearch.MainTable.Column.Facility',
      'BillSearch.MainTable.Column.InOutType', 'BillSearch.MainTable.Column.DiffRatio','BillSearch.MainTable.Column.DiffAmount'];

    // Match by field name instead of hardcoded index - the old index list drifted out of sync with `fields`
    const dateFields = new Set(['applyDt', 'guiDt', 'dueDt', 'cancelDt', 'createDt', 'updateDt']);

    for (let i = 0; i < fields.length; i++) {
      this.translateService.get(jsons[i])
        .subscribe((translation: string) => {
          tmpcolumn[i] = {
            field: fields[i],
            header: translation,
            dataType: dateFields.has(fields[i]) ? 'date' : undefined,
            sort: true
          };
        });
    }
    return tmpcolumn;
  }

  importExcelBtn() {
    this.routeStateService.navigateTo('/BillConfig/BillImport', null);
  }


  openDownloadBillView() {
    // 如果User只選擇CB/CT這兩種單據，下載Excel Type只能保留CB這種方式，不然容易造成User手誤
    const types = [...new Set(this.selectedRowsWithCheckBox.map(row => row.billingNo.substr(2, 2)))];
    const allowedTypes = ['CB', 'CT'];
    const onlyCBorCT = types.length > 0 && types.every(type => allowedTypes.includes(type));

    this.billCodeKeyOptions = onlyCBorCT
      ? this.billCodeKeyOptionsOriginal.filter(option => option.value === 'CB')
      : [...this.billCodeKeyOptionsOriginal];

    this.isShowExcelModal = true;
  }

  confirmBtnClick(): void {
    this.isHeaderLoading = true;
    this.isDetailLoading = true;
    const updateObj = {
      billingDetailSeqNo: this.selectedRowsWithCheckBox.map(x => x.seqNo),
      createUser: this.userProfile.userName,
      employeeCode: this.userProfile.employCode,
      userType: this.userProfile.userType
    };
    this.billService.confirmPaymentApplication(updateObj).subscribe({
      next: result => {
        if (isNullOrEmpty(result.errorMsg)) {
          this.toastService.success(this.translateService.instant('BillSearch.Success.ConfirmSuccess'));
          this.searchBtnClick();
        } else {
          this.toastService.error(result.errorMsg);
        }
      },
      error: err => {
        if (err.error.errorMsg) {
          this.toastErrorMessage(err.error);
        }
        this.isHeaderLoading = false;
        this.isDetailLoading = false;
      },
      complete: () => {
        this.isHeaderLoading = false;
        this.isDetailLoading = false;
      }
    });
  }

  cancelBtnClick(): void {

    this.confirmationService.confirm({
      header: this.translateService.instant('Common.Confirm.Header'),
      message: this.translateService.instant('BillSearch.BillAdd.Message.ConfirmCancelBilling'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.isHeaderLoading = true;
        this.isDetailLoading = true;
        const updateObj = {
          billDetailSeqNos: this.selectedRowsWithCheckBox.map(x => x.seqNo),
          updateUser: this.userProfile.userName
        };

        this.billService.cancelPaymentApplication(updateObj).subscribe({
          next: result => {
            this.toastService.success(this.translateService.instant('BillSearch.Success.CancelSuccess'));
            this.searchBtnClick();
          },
          error: err => {
            this.toastErrorMessage(err.error);
            this.isHeaderLoading = false;
            this.isDetailLoading = false;
          }
        });
      }
    });

  }

  downloadBillExcelBtn() {

    if(this.pageInfo.totalRecords == 0){
      this.toastService.info(this.translateService.instant('BillSearch.Alert.Tick'));
      return;
    }

    if (this.billCodeKey == "") {
      this.toastService.info(this.translateService.instant('BillSearch.Alert.SelectFormat'));
      return;
    }


    if (this.selectedRowsWithCheckBox.length == 0) {

      let request = deepCopy(this.searchForm.value);
      request.facility = this.laasSetting.facility;
      request.userName = this.userProfile.userName;
      request.userUUId = this.userProfile.uuid;
      request.userType = this.userProfile.userType;
      request.authToken = this.authenticationService.currentToken;
      request.pageSize = this.pageInfo.totalRecords;
      request.pageIndex = 0;
      request.sortInfo = this.sortInfo;
      request.facilityList = getFacilityByPermission(this.userProfile, "ViewBilling");
      this.billService
      .searchBill(request)
      .subscribe({
        next: (result) => {
          let seqNo = result.content.map((a: { seqNo: any; }) => a.seqNo);
          this.billExcel(seqNo);
        },
      });

    }else{
      let seqNo = this.selectedRowsWithCheckBox.map(a => a.seqNo);
      this.billExcel(seqNo);
    }

  }


  billExcel(seqNos : any[]){

    console.log("seqNos:",seqNos);

    this.isHeaderLoading = true;
    let fileDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    let facility = this.laasSetting.facility;
    let codeKey = this.billCodeKey;

    let tempObj: any;
    tempObj = { facility: facility, codeKey: codeKey, seqNos: seqNos };

    this.billService.getBillExcel(tempObj).subscribe({
      next: result => {

        if (result == null || result.size == 0) {
          this.toastService.info(this.translateService.instant('BillSearch.Alert.NoFound'));
          this.loader.hide();
        } else {
          const file = result;
          file.name = fileDate + "_Bill REPORT";
          const url = URL.createObjectURL(file);
          let a: any = document.createElement('a');
          a.href = url
          a.download = file.name;
          a.click();
          URL.revokeObjectURL(url);
          this.isHeaderLoading = false;
        }
      },
      complete: () => {
        this.isHeaderLoading = false;
      }
    })
  }


  modalCancelBtnClick(event: any): void {
    this.billCodeKey = "";
    this.isShowExcelModal = false;
  }

  getRowSum() {
    let amountSum: number = 0;
    let estimatedAmountSum: number = 0;
    let linePayAmountSum: number = 0;
    let applyAmountSum: number = 0

    for (const row of this.selectedRowsWithCheckBox) {
      amountSum = amountSum + row.amount;
      estimatedAmountSum = estimatedAmountSum + row.estimatedAmount;
      linePayAmountSum = linePayAmountSum + row.linePayAmount;
      applyAmountSum = applyAmountSum + row.applyAmount;
    }

    return { amount: amountSum, estimatedAmount: estimatedAmountSum, linePayAmount: linePayAmountSum, applyAmount: applyAmountSum };
  }

  chipsAdd(event: any, fromControlName: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    const formControl = this.searchForm.get(fromControlName);
    formControl?.value.splice(formControl?.value.indexOf(value));
    formControl?.setValue(formControl?.value.concat(parsedValues));
  }

  amountChangeEvent(rowData: any) {
    const diffResult = this.calculateDiffRatio(rowData);

    rowData.diffRatio = diffResult.ratio;
    rowData.diffAmount = diffResult.amount;
    this.transformLinePayAmount(rowData);
  }

  calculateDiffRatio(rowData: any) {
    const amount = rowData.amount - rowData.estimatedAmount;
    const ratio = amount / rowData.estimatedAmount * 100;

    return {amount: amount.toFixed(2), ratio: Math.round(ratio)};
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case "billDate":
        this.searchForm.controls.billDtStart.setValue(date.startDate);
        this.searchForm.controls.billDtEnd.setValue(date.endDate);
        break;
    }
  }
  checkBillConfirm() {
    // validate
    if(!this.checkBillType) {
      this.toastService.info(this.translateService.instant('BillSearch.Alert.CheckBillType'));
      return;
    }
    if(!this.checkBillTarget || this.checkBillTarget.length === 0) {
      this.toastService.info(this.translateService.instant('BillSearch.Alert.CheckBillTargets'));
      return;
    }
    // call checkBill API
    this.checkBillLoading = true;
    this.billService.checkBill({
      checkBillTarget: this.checkBillTarget,
      checkBillType: this.checkBillType,
    }).subscribe({
      next: response => {
        this.checkBillLoading = false;
        const contentType = response.headers.get('Content-Type');
        if(contentType?.includes('application/octet-stream')) {

          this.isHeaderLoading = true;
          let fileDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
          const file = response.body;
          file.name = fileDate + "_Bill_Check.xlsx";
          const url = URL.createObjectURL(file);
          let a: any = document.createElement('a');
          a.href = url
          a.download = file.name;
          a.click();
          URL.revokeObjectURL(url);
          this.isHeaderLoading = false;
        } else {
          // 非檔案 = 成功
          this.toastService.success(this.translateService.instant('BillSearch.Success.CheckBillSuccess'));
        }

      },
      error: err => {
        this.checkBillLoading = false;
        this.toastErrorMessage(err.error);
        this.isHeaderLoading = false;
      },
      complete: () => {
        this.showCheckModal = false;
        this.checkBillTarget = [];
        this.checkBillType = null;
      }
    })
  }
  // on chip add
  onCheckBilTargetAdd(event: ChipsAddEvent): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').map(x => x.trim()).filter(x => !isNullOrEmpty(x));
    this.checkBillTarget.splice(this.checkBillTarget.indexOf(value), 1); // 移除原有值
    this.checkBillTarget = [...new Set([...this.checkBillTarget, ...parsedValues])]; // 加上調整後值 && 去除重複值 && 響應畫面
  }
  onCheckModalHide() {
    this.checkBillTarget = [];
    this.checkBillType = null;
  }
}
